import {Hidden, Slide, Paper, Badge} from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import * as React from "react";
import {FC, useEffect, useState, useMemo} from "react";
import {useRouter} from "next-translate-routes/router";
import {fileUrlToUrl, urlToFileUrl} from "next-translate-routes"
import {useAuth} from "../hooks/use-auth";
import {useDispatch} from "../store";
import {setShowAuthWall} from "../slices/user-session-slice";
import {useTranslation} from "next-i18next";


const convertRouteToIndex = (route: string) => {

    switch (route) {
        case "/diving":
            return 0
        case "/interested":
            return 1
        default:
            return 1
    }
}


export const BottomMobileNav: FC = () => {
    const router = useRouter()

    const [value, setValue] = React.useState(convertRouteToIndex(router.route));

    const {isAuthenticated, user} = useAuth()

    const {t} = useTranslation()

    const dispatch = useDispatch()

    useEffect(() => {

        switch (value) {
            case 0:
                if (!urlToFileUrl(router)?.pathname?.startsWith("/diving")) {
                    console.log("bottom mobile nave trying to navigate to diving")
                    router.push({pathname: "/diving"})
                }
                break;
            case 1:
                if (!urlToFileUrl(router)?.pathname?.startsWith("/interested")) {
                    console.log("bottom mobile nave trying to navigate to interested")
                    router.push({pathname: "/interested"})
                }
                break;
            case 2:

            default:
                router.push("/")
        }

    }, [value])


    const [drawerOpen, setDrawerOpen] = React.useState(true);


    const [scrollDir, setScrollDir] = useState("scrolling up");

    useEffect(() => {
        const threshold = 100;
        let lastScrollY = window.pageYOffset;
        let ticking = false;

        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };

        window.addEventListener("scroll", onScroll);
        // console.log(scrollDir);
        // console.log(router.route)

        if (scrollDir === "scrolling down") {
            setDrawerOpen(false)
        } else {
            setDrawerOpen(true)
        }

        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollDir]);


    return (<Hidden mdUp>
            <Slide
                direction={"up"}
                timeout={{
                    appear: 1000,
                    enter: 700,
                    exit: 400
                }}
                in={drawerOpen}

            >
                <Paper sx={{
                    position: "fixed",
                    minHeight: 157,
                    bottom: -100,
                    left: 0,
                    right: 0,
                    px: 2,
                    borderTop: "1px solid #cecece",
                    zIndex: 1000
                }} elevation={4}>

                    <BottomNavigation

                        showLabels
                        value={value}
                        onChange={(event, newValue) => {
                            if (newValue === 2 || newValue === 3) {

                                if (isAuthenticated) {
                                    router.push({
                                        pathname: "/u/[username]",
                                        query: {username: user?.username}
                                    })
                                } else {
                                    dispatch(setShowAuthWall(true))
                                }

                            } else {
                                setValue(newValue);
                            }

                        }}
                    >
                        <BottomNavigationAction label={t("explore")} icon={<SearchIcon/>}/>
                        <BottomNavigationAction label={t("interested")} icon={<FavoriteIcon/>}/>
                        {isAuthenticated &&
                            <BottomNavigationAction label={t("profile")} icon={<AccountCircleIcon/>}/>
                        }

                        {!isAuthenticated
                            &&
                            <BottomNavigationAction label={t("login")} icon={<Badge variant={"dot"}
                                                                                    color={"secondary"}><AccountCircleIcon/></Badge>}/>
                        }


                    </BottomNavigation>
                </Paper>
            </Slide>
        </Hidden>
    )

}
